export const Draft = {
    name: 'Draft',
    value: 'DRAFT',
    sequence: 1,
};
export const Active = {
    name: 'Active',
    value: 'ACTIVE',
    sequence: 2,
};
export const Inactive = {
    name: 'Inactive',
    value: 'INACTIVE',
    sequence: 3,
};
export const Deleted = {
    name: 'Deleted',
    value: 'DELETED',
    sequence: 4,
};
const Basic = [Draft, Active, Inactive, Deleted];
const BasicByValue = Basic.reduce((hash, status) => {
    hash[status.value] = status;
    return hash;
}, {});
const BasicProps = Object.keys(BasicByValue);
export const isActive = status => status === Active.value;
export default {
    Basic,
    BasicByValue,
    BasicProps,
    Draft,
    Active,
    Inactive,
    Deleted,
    isActive,
};
